import { cn } from '@lib/utils'
import { ComponentProps, FC } from 'react'

const GreenBarForMobile: FC<ComponentProps<'div'>> = ({ className, children, ...props }) => {
  return (
    <div {...props} className={cn(className, 'bg-[#6ea84a] text-white text-center p-2 md:hidden')}>
      {children}
    </div>
  )
}

export default GreenBarForMobile
